import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "value",
      description: "绑定值",
      type: "string"
    },
    {
      prop: "theme",
      description: "主题 border || card || darkbg || lightborder,",
      type: "String",
      default: "border"
    },
    {
      prop: "allowEmpty",
      description: "是否允许搜索空",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "clearable",
      description: "是否可清除",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "clearAfterSearch",
      description: "只有搜索过才显示清除",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "clearForce",
      description: "只根据hover判断是否显示清除",
      type: "Boolean",
      default: "false"
    }
  ],
  events: [
    {
      name: "search",
      description: "搜索"
    }
  ],
  methods: [],
  slots: [
    {
      name: "默认slot",
      description: "自动补全下拉框"
    }
  ]
};

export default DemoWrapper(Demo, DemoSource, config);
